import { LogoImageProps } from '../'

export const DesktopBwinLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/bwin.svg',
    width: 42,
    height: 14,
}

export const DesktopHpybetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/hpybet.svg',
    width: 70,
    height: 20,
}

export const DesktopInterwettenLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/iw_desktop.svg',
    width: 91,
    height: 18,
}

export const DesktopTipicoLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/tipico.svg',
    width: 45,
    height: 14,
}

export const DesktopUnibetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/unibet.png',
    width: 47,
    height: 20,
}

export const DesktopNeoBetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/neobet_logo.png',
    width: 43,
    height: 15,
}
